import React from "react";
import Button from "@mui/material/Button";

const SignerActions = ({
  row,
  signers,
  setSigners,
  deletedAfms,
  setDeletedAfms,
  setSelectedAfm,
  setDeleteDialogOpen,
  setNotification,
}) => {
  const handleRestoreClick = (row) => {
    const totalSignersLength = signers.length - deletedAfms.length;

    if (totalSignersLength < 10) {
      setDeletedAfms((prevIds) => {
        const newIds = prevIds.filter((id) => id !== row.afm);
        return newIds;
      });

      setSigners((prevSigners) =>
        prevSigners.map((signer) =>
          signer.afm === row.afm ? { ...signer, isDeleted: false } : signer,
        ),
      );
    } else {
      setNotification({
        open: true,
        color: "error",
        message:
          "Δεν επιτρέπεται η επαναφορά όταν ο συνολικός αριθμός υπογραφόντων είναι 10.",
      });
    }
  };

  const handleDeleteClick = (row) => {
    setSelectedAfm(row.afm);
    setDeleteDialogOpen(true);
  };

  return (
    <div>
      {deletedAfms.includes(row.afm) ? (
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleRestoreClick(row)}
          style={{
            width: 120,
          }}
        >
          Επαναφορά
        </Button>
      ) : (
        <Button
          variant="contained"
          color="error"
          onClick={() => handleDeleteClick(row)}
          style={{
            width: 120,
          }}
        >
          Διαγραφή
        </Button>
      )}
    </div>
  );
};

export default SignerActions;
